import {
  Arbitrum,
  Avalanche,
  Bitcoin,
  Bnb,
  Bsc,
  Cardano,
  Cosmos,
  Cronos,
  Doge,
  Eth,
  Fantom,
  IconPropsType,
  Irr,
  MoonpayIcon,
  Near,
  Optimism,
  Polkadot,
  Polygon,
  Ripple,
  Shiba,
  Solana,
  Thorchain,
  Tron,
  Trump,
  Usd,
  Usdt,
  Vatan,
} from '@repo/icons';

export const CurrencyIconsMap: { [key: string]: React.FC<IconPropsType> } = {
  usd: Usd,
  irr: Irr,
  irt: Irr,
  arbitrum: Arbitrum,
  avalanche: Avalanche,
  bitcoin: Bitcoin,
  bsc: Bsc,
  btc: Bitcoin,
  cardano: Cardano,
  cosmos: Cosmos,
  cronos: Cronos,
  doge: Doge,
  eth: Eth,
  fantom: Fantom,
  near: Near,
  optimism: Optimism,
  polkadot: Polkadot,
  polygon: Polygon,
  ripple: Ripple,
  solana: Solana,
  sol: Solana,
  thorchain: Thorchain,
  trx: Tron,
  tron: Tron,
  usdt: Usdt,
  vatan: Vatan,
  bnb: Bnb,
  trump: Trump,
  moonpay: MoonpayIcon,
  shiba: Shiba,
  shib: Shiba,
} as const;

export const CurrencyIcon = ({ currency, className }: IconPropsType & { currency?: string }) => {
  if (!currency) return null;

  const CurrencyIconComponent = CurrencyIconsMap?.[currency?.toLowerCase() as keyof typeof CurrencyIconsMap];

  if (!CurrencyIconComponent) return null;

  return <CurrencyIconComponent className={className} />;
};
